/**
 * A sidebar item is active when the current path is its link or a page under
 * it. Paths are compared by whole segments, so `/admin/company` does not match
 * `/admin/company-setup/...`. The query string and hash are ignored.
 */
export const isSidebarLinkActive = (asPath: string, link: string): boolean => {
  const path = asPath.split(/[?#]/u)[0];
  const linkPath = link.split(/[?#]/u)[0];

  return path === linkPath || path.startsWith(`${linkPath}/`);
};
